import { render } from "./CountryIndicator.vue?vue&type=template&id=22254243"
import script from "./CountryIndicator.vue?vue&type=script&lang=js"
export * from "./CountryIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__